// extracted by mini-css-extract-plugin
export default {"root":"UserProfile_root__-zZx3","modalTextInput":"UserProfile_modalTextInput__X867X"};